import { render } from "./SubstepComponent.vue?vue&type=template&id=c48da514&scoped=true"
import script from "./SubstepComponent.vue?vue&type=script&lang=js"
export * from "./SubstepComponent.vue?vue&type=script&lang=js"

import "./SubstepComponent.vue?vue&type=style&index=0&id=c48da514&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48da514"]])

export default __exports__